import React, { Component, PropTypes } from 'react';
import queryString from 'query-string';
import {
  List,
  ListItem,
  Divider,
  RaisedButton,
  FontIcon,
  IconButton,
  MenuItem,
  IconMenu,
} from 'material-ui';
import Card from '../tc-ui/search-bar-card';
import languagesObj from '../../localization/languages.json';
import Pagination from '../tc-ui/pagination/pagination';
import moment from 'moment';
import R from 'ramda';
const languageSettings = languagesObj['en-US'];

class IntegrationContracts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
    };
    this.populateInitalState(props, R.clone(this.state));
  }
  componentDidMount() {
    const { getContracts } = this.props;
    getContracts({ page: 1 });
  }

  componentWillReceiveProps(props) {
    this.populateInitalState(props, this.state);
  }
  populateInitalState(props, state) {
    const contractsFromStateStore = props.integration.contracts || [];
    const productTypesForFilter = [];
    const contractYearsForFilter = [];
    this.state = {
      ...state,
      sortValue: '2',
      productTypesForFilter,
      contractYearsForFilter,
      filtersSelected: productTypesForFilter.concat(contractYearsForFilter),
    };
  }
  goToPage = page => {
    this.setState({ page });
    this.props.getContracts({ page });
  };
  _searchWithInput(input) {
    this.setState({ searchInput: input, page: 1 }, this._handleSearch);
  }

  _handleSortChange(e, value) {
    this.setState({ sortValue: value, page: 1 }, this._handleSearch);
  }

  // _handleFilterChange(e, value) {
  //   this.setState({ filtersSelected: value });
  // }

  _handleSearch = () => {
    const { sortValue, searchInput } = this.state;
    if (sortValue === '1') this.props.getContracts({ sortKey: 'from.name', sort: -1, page: 1, searchInput });
    else if (sortValue === '2') this.props.getContracts({ sortKey: '_id', sort: -1, page: 1, searchInput });
    else if (sortValue === '3') this.props.getContracts({ sortKey: '_id', sort: 1, page: 1, searchInput });
    else if (sortValue === '4') this.props.getContracts({ sortKey: 'lastExport.date', sort: -1, page: 1, searchInput });
    else this.props.getContracts({ page: 1, searchInput });
  };

  _handleDownloadClick = (contractId) => e => {
    this.props.dispatch({
      type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
      payload: {
        docId: contractId,
        collection: 'contract',
        anchorEl: e.currentTarget,
      },
    });
  }

  render() {
    const { history, integration } = this.props;
    if (integration.loadingContracts === 'loading' || !integration.contracts) {
      return (<Card>
        <div className="no-connections-loading" style={{ width: '100%', height: '100px' }}>
          <div className="load-bar loader"/>
        </div>
      </Card>);
    } else if (integration.loadingContracts === 'failed') {
      return (<div>{"Failed to load contracts, please try again or contact customer support if it happens again"}</div>);
    } else if (integration.loadingContracts === 'success') {
      const contracts = integration.contracts.map((contract = {}) => {
        const supplierName = R.pathOr(R.pathOr('', ['from', 'name'], contract), ['partners', 0, 'name'], contract);
        const locationName = contract.locationName;
        const contractYear = `${moment.utc(contract.startDate).format('D MMM YY')} - ${moment.utc(contract.endDate).format('D MMM YY')}`;
        const isExported = contract.lastExport;
        const newObj = {
          productType: contract.productType,
          supplierInfo: contract.supplierInfo,
          supplierName,
          locationName,
          isExported,
          contractYear,
          updatedAt: contract.updatedAt,
          contractId: contract._id,
          versions: contract.versions,
        };
        if (isExported) {
          newObj.isExported.timestamp = moment(isExported.date).calendar(null, {
            sameDay: 'h:mm a l',
            lastDay: 'l',
            lastWeek: 'l',
            sameElse: 'l',
          });
        }
        return newObj;
      });
      // const productTypesFilter = this.state.productTypesForFilter.map((productType, index) => {
      //   const checked = this.state.filtersSelected.indexOf(productType) !== -1;
      //   return <MenuItem key={`${productType}${index}`} checked={checked} value={productType} primaryText={productType} />;
      // });
      // const contractYearsFilter = this.state.contractYearsForFilter.map((contractYear, index) => {
      //   const checked = this.state.filtersSelected.indexOf(contractYear) !== -1;
      //   return <MenuItem key={`${contractYear}${index}`} checked={checked} value={contractYear} primaryText={contractYear} />;
      // });
      const titleBarExtra = (
        <div style={{
          display: 'inline-block',
          float: 'right',
          fontSize: '16px',
          color: 'rgba(0,0,0,.26)',
          cursor: 'pointer',
          }}
        >
          <IconMenu closeOnItemTouchTap={false} desktop onChange={this._handleSortChange.bind(this)} value={this.state.sortValue} openDirection="bottom-right" iconButtonElement={<IconButton tooltip="Sort" tooltipPosition="top-right" iconClassName="tc-icon-move-down" iconStyle={{ color: 'rgba(0,0,0,.26)' }} />}>
            <MenuItem value="1" primaryText="Alphabetically" />
            <MenuItem value="2" primaryText="Last Completed" />
            <MenuItem value="3" primaryText="Earliest Completed" />
            <MenuItem value="4" primaryText="Export Date" />
          </IconMenu>
          {/*<IconMenu closeOnItemTouchTap={false} desktop multiple onChange={this._handleFilterChange.bind(this)} value={this.state.filtersSelected} openDirection="bottom-right" iconButtonElement={<IconButton tooltip="Filters" tooltipPosition="top-right" iconClassName="tc-icon-filter" iconStyle={{ fontSize: '18px', color: 'rgba(0,0,0,.26)' }} />}>*/}
          {/*  <MenuItem primaryText="Product Type" disabled />*/}
          {/*  {productTypesFilter}*/}
          {/*  <Divider />*/}
          {/*  <MenuItem primaryText="Contract Year" disabled />*/}
          {/*  {contractYearsFilter}*/}
          {/*</IconMenu>*/}
        </div>
      );
      return (
        <Card title={languageSettings.integration.routeNames.contracts}
          isSticky
          searchHeader
          search
          listCard
          padded={false}
          searchWithInput={this._searchWithInput.bind(this)}
          titleBarExtra={titleBarExtra}
          defaultValue={this.state.searchInput}
          searchBarHintText="Search..."
        >
          <div>
            {
              (() => {
                if (integration.totalContractsNo < 1) {
                  return (<div className="no-connections"><h4 className="no-connections-message"> {"Sorry, no contracts were found."}</h4></div>);
                }
                return contracts.map((contract, index) => {
                  const iconButtonElement = (<IconButton iconStyle={{ color: '#888' }} iconClassName="tc-icon-more-vert" />);
                  const rightIconMenu = (
                    <IconMenu desktop onItemTouchTap={this._handleDownloadClick(contract.contractId)} style={{ marginTop: '5px' }} iconButtonElement={iconButtonElement} openDirection="bottom-right">
                      <MenuItem primaryText="Download" />
                    </IconMenu>
                  );
                  const { secondline, button } = (() => {
                    if (contract.isExported) {
                      return {
                        secondline: (<div style={{ display: 'block' }}>{`Last exported on: ${contract.isExported.timestamp} by ${contract.isExported.user}`}</div>),
                        button: (
                          <RaisedButton
                            label="re-export"
                            secondary
                            style={{ float: 'right', width: '120px', minWidth: '120px' }}
                            onClick={() => {
                              history.push(`/integration/product-mapping/${contract.contractId}`);
                            }
                            }
                          />),
                      };
                    }
                    return {
                      secondline: ' ',
                      button: (
                        <RaisedButton
                          label="export"
                          primary
                          style={{ float: 'right', width: '120px', minWidth: '120px' }}
                          onClick={() => {
                            history.push(`/integration/product-mapping/${contract.contractId}`);
                          }
                          }
                        />),
                    };
                  })();

                  const primaryText = (
                    <div>
                      {contract.supplierName}
                      <a style={{ fontSize: '16px', cursor: 'pointer' }} target="__blank" href={`/contracting/contract/${contract.contractId}/details`}>
                        <FontIcon style={{ fontSize: '16px', marginLeft: '15px' }} color={"#00bcd4"} className="tc-icon-archive" />
                        <span style={{ fontSize: '14px', fontWeight: '400' }}>{` ${contract.locationName}`}</span>
                        {
                          R.path(['supplierInfo', 'marketInfo'], contract) ? (<small>
                            &nbsp;{`(${R.path(['supplierInfo', 'marketInfo'], contract)})`}
                          </small>) : <span/>
                        }
                        <small>{`(v.${contract.versions.length + 1})`}</small>
                      </a>
                      {button}
                    </div>
                  );
                  const secondaryText = (<div>
                    <strong>{'Year: '}</strong><small>{contract.contractYear}</small>
                    &nbsp;&nbsp;<strong>Last Updated: </strong>
                    <small>{moment(contract.updatedAt).calendar(null, {
                      sameDay: 'h:mm a l',
                      lastDay: 'l',
                      lastWeek: 'l',
                      sameElse: 'l',
                    })}</small>
                    {secondline}
                  </div>);
                  const listDivider = index !== contracts.length - 1 ? <Divider /> : undefined;
                  return (
                    <div style={{ fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif" }} key={index}>
                      <ListItem
                        disabled
                        primaryText={primaryText}
                        secondaryText={secondaryText}
                        rightIconButton={rightIconMenu}
                        secondaryTextLines={2}
                      />
                      {listDivider}
                    </div>
                  );
                });
              })()
            }
            {Math.ceil(integration.totalContractsNo / 10) > 1 ? (
              <Pagination
                currentPage={this.state.page}
                totalPages={Math.ceil(integration.totalContractsNo / 10)}
                goToPage={this.goToPage}
                noOfPagesToShow={5}
              />) : <span/>}
          </div>
        </Card>
      );
    }
  }
}

IntegrationContracts.propTypes = {
  config: PropTypes.object,
  getContract: PropTypes.func,
  getContracts: PropTypes.func,
  user: PropTypes.object,
  integration: PropTypes.object,
  history: PropTypes.object,
};

export default IntegrationContracts;



// WEBPACK FOOTER //
// ./src/app/components/integration/integration-contracts.jsx